<template>
    <div :class="{ 
            'toggle-switch': true, 
            'toggle-switch--on': state == 1 
        }" >

        <span v-if="label" class="toggle-switch__label label">
            {{ label }}
        </span>
        
        <button
            class="toggle-switch__switch"
            @click="state = (state == 1 ? 0 : 1)"
            @mouseenter="hover = true"
            @mouseleave="hover = false">

            <span class="toggle-switch__slider"></span>
        </button>

        <popover 
            v-if="popover && hover"
            :target="$el" 
            :close-btn="false" 
            position="top"
            class="">

            <slot name="popover">
                {{ popover }}
            </slot>
        </popover>
    </div>
</template>

<script>
export default {
    props: {
        value: {
            type: Number,
            default: 0
        },
        label: {
            type: String
        },
        popover: {
            type: Boolean | String
        }
    },
    data() {
        return {
            state: this.value,
            hover: false
        }
    },
    watch: {
        value: function(newStateValue) {
            this.state = newStateValue;
        },
        state: function(newState) {
            this.$emit('changed', this);
            
            if(newState == 1) {
                this.$emit('on', this);
            } else {
                this.$emit('off', this);
            }
        }
    }
}
</script>

<style lang="scss">
.toggle-switch {
    &__switch {
        position: relative;
    }

    &__slider {
        display: block;
        position: absolute;
        left: 0;
        transition: all 0.3s;
    }

    &--on &__slider {
        left: 100%;
        transform: translateX(-100%);
    }
}
</style>